<template>
  <div class>
    <STable ref="tableref" :url="url" :selection="false" :columns="columns" :handle="handle" :handles="handles"
      :query="query" :toolbar="toolbar" label-width="100px" cnames="电桩状态" />
  </div>
</template>

<script>
export default {
  name: 'Hulianhutongdianzhan',
  components: {},
  data() {
    return {
      url: '/station/hlht',
      columns: [{
        label: '电站名称',
        prop: 'stationName'
      },
      {
        label: '电站地址',
        prop: 'address'
      },
      {
        label: '运营商',
        prop: 'operatorName'
      },
      {
        label: '区划',
        prop: 'cityName'
      },
      // {
      //     label: "场地属性",
      //     prop: "siteProperties",
      // },
      {
        label: '电站类型',
        prop: 'stationTypeValue'
      },
      {
        label: '建设场所',
        prop: 'constructionValue'
      },
      {
        label: '开放时间',
        prop: 'busineHoursInstruction'
      },
      {
        label: '启停状态',
        prop: 'disable',
        template: function (index, reocrd) {
          return reocrd.disable
            ? "<span class='tag danger'>停用</span>"
            : "<span class='tag success'>启用</span>"
        }
      }
      ],

      // 操作栏
      handle: {
        width: 100,
        btns: [{
          label: '查看',
          permission: '',
          handle: resp => { }
        }]
      },

      // 操作栏
      handles: {
        width: 260,
        btns: [
          {
            label: '详情',
            permission: 'valueadd.interconnection.details',
            handle: resp => {
              console.log(resp)
              this.$router.push({
                path: './InterConStationDetail',
                query: { data: resp.id }
              })
            }
          },
          {
            label: '启用',
            permission: 'valueadd.interconnection.Enable',
            style: 'color:red',
            getLabel: function (record) {
              return record.disable ? '启用' : '停用'
            },
            getLabelStyle: record => {
              return record.disable ? '' : 'color:red'
            },
            url: '/station/hlht/disable',
            method: 'post',
            isConfirm: true,
            confirmText: '是否确定执行本操作？',
            before: function (index, record) {
              const p = {
                id: record.id,
                disable: !record.disable
              }
              return p
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '更新价格',
            permission: 'valueadd.interconnection.Enable',
            style: 'color:green;',
            url: '/station/hlht/disable',
            method: 'post',
            isConfirm: true,
            confirmText: '是否确认更新该场站电价?',
            before: function (index, record) {
              const p = {
                id: record.id,
                disable: !record.disable
              }
              return p
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '电站名称',
          prop: 'name',
          placeholder: '请输入电站名称'
        },
        {
          label: '归属运营商',
          prop: 'operatorName',
          placeholder: '请输入归属运营商'
        },
        {
          label: '启停状态',
          prop: 'system',
          placeholder: '请选择状态',
          type: 'select',
          data: [
            {
              label: '启用',
              value: '0'
            },
            {
              label: '停用',
              value: '1'
            }
          ]
        },
        {
          label: '电站城市',
          prop: 'stationCity',
          placeholder: '请选择电站城市'
        },
        {
          label: '电站地址',
          prop: 'stationAddress',
          placeholder: '请输入电站地址'
        },
        {
          label: '场地属性',
          prop: 'stationAttribute',
          placeholder: '请选择属性',
          type: 'select',
          data: [
            {
              label: '独立场站',
              value: '0'
            },
            {
              label: '混合场站',
              value: '1'
            }
          ]
        },
        {
          label: '电站类型',
          prop: 'stationType',
          placeholder: '请选择电站类型',
          type: 'select',
          data: [
            {
              label: '公共',
              value: '1'
            },
            {
              label: '个人',
              value: '50'
            },
            {
              label: '公交(专用)',
              value: '100'
            },
            {
              label: '环卫(专用)',
              value: '101'
            },
            {
              label: '物流(专用)',
              value: '102'
            },
            {
              label: '出租车(专用)',
              value: '103'
            },
            {
              label: '其他',
              value: '255'
            }
          ]
        },
        {
          label: '建设场所',
          prop: 'construction',
          placeholder: '请选择建设场所',
          type: 'select',
          data: [
            {
              label: '居民区',
              value: '1'
            },
            {
              label: '公共机构',
              value: '2'
            },
            {
              label: '企事业单位',
              value: '3'
            },
            {
              label: '写字楼',
              value: '34'
            },
            {
              label: '工业园区',
              value: '5'
            },
            {
              label: '交通枢纽',
              value: '6'
            },
            {
              label: '大型文体设施',
              value: '7'
            },
            {
              label: '城市绿地',
              value: '8'
            },
            {
              label: '大型建筑配建停车场',
              value: '9'
            },
            {
              label: '路边停车位',
              value: '109'
            },
            {
              label: '城际高速服务区',
              value: '11'
            },
            {
              label: '其他',
              value: '255'
            }
          ]
        }
      ],
      toolbar: [
      ],
      dialogVisible: false,
      form: {
        operatorIds: [],
        stationIds: [],
        mechanismIds: []
      },
      operatortree: [],
      stationtree: [],
      mechanismtree: []
    }
  },
  methods: {
    cancel1() {
      this.form.operatorIds = []
      this.form.stationIds = []
      this.form.mechanismIds = []
      this.dialogVisible = false
    },
    save1() {

    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/plantManagement/InterconnectedStation.vue